// extracted by mini-css-extract-plugin
module.exports = {"dataLabel":"VerboseStationInfo__dataLabel___2JlBx"};